import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"
import 'tom-select/dist/css/tom-select.css'
import '../stylesheets/tom-select.scss'

export default class extends Controller {
  static targets = ["select"]
  static values = {
    url: String
  }

  connect() {
    this.initializeTomSelect()
  }

  initializeTomSelect() {
    if (!this.hasSelectTarget) return;

    this.tomselect = new TomSelect(this.selectTarget, {
      valueField: 'id',
      labelField: 'text',
      searchField: ['text'],
      placeholder: "Kompetenz suchen...",
      openOnFocus: true,
      preload: 'focus',
      closeAfterSelect: true,
      selectOnTab: true,
      maxOptions: 100,
      load: (query, callback) => {
        if (!query.length) return callback();
        
        // Verwende die Backend-Such-API
        const url = `/de/backend/search/?model=competencies&term=${encodeURIComponent(query)}`
        
        fetch(url)
          .then(response => response.json())
          .then(json => {
            callback(json)
          }).catch(() => {
            callback()
          })
      },
      render: {
        no_results: function(data, escape) {
          return '<div class="no-results">Keine Ergebnisse für "' + escape(data.input) + '"</div>';
        },
        option: function(item, escape) {
          return `<div class="option">
            <span class="title text-sm">${escape(item.text)}</span>
            ${item.subtext ? `<span class="subtext text-xs text-gray-500">${escape(item.subtext)}</span>` : ''}
          </div>`
        },
        item: function(item, escape) {
          return `<div class="item text-sm">${escape(item.text)}</div>`
        }
      },
      onChange: (value) => {
        if (value) {
          // Automatisch das Formular absenden, wenn eine Kompetenz ausgewählt wurde
          const form = this.selectTarget.closest('form');
          if (form) {
            form.requestSubmit();
          }
        }
      }
    })
  }

  setWeight(event) {
    const weight = event.currentTarget.dataset.weight
    const hiddenField = this.selectTarget.closest('form').querySelector('input[name="competency_requirement[weight]"]')
    if (hiddenField) {
      hiddenField.value = weight
    }
    
    // Aktualisiere die visuelle Darstellung
    const buttons = this.element.querySelectorAll('[data-action*="setWeight"]');
    buttons.forEach(button => {
      if (button.dataset.weight === weight) {
        button.classList.add('bg-atorange-50', 'border-atorange-500', 'text-atorange-700');
        button.classList.remove('bg-white', 'text-gray-700');
      } else {
        button.classList.remove('bg-atorange-50', 'border-atorange-500', 'text-atorange-700');
        button.classList.add('bg-white', 'text-gray-700');
      }
    });
  }

  disconnect() {
    if (this.tomselect) {
      this.tomselect.destroy();
    }
  }
} 